// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__Or4Ju","right":"styles_right__1hfbo"};